import React from 'react';

import { DatedRasterCompareContext } from './FmDatedRasterCompareContext';

export function FmDatedRasterCompareProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [reveal, setReveal] = React.useState(50);
  const value = React.useMemo(() => ({ reveal, setReveal }), [reveal]);
  return (
    <DatedRasterCompareContext.Provider value={value}>
      {children}
    </DatedRasterCompareContext.Provider>
  );
}
